  import axios from 'axios'
  import { REACT_APP_API } from '../../../config'
  
  export async function getKeywords(inputValue) {
    return axios.get(`${REACT_APP_API}/dictionary/keywords/${inputValue.trim()}`).then((res) => {
      return res.data.data.map((opcion) => ({ label: opcion.value, value: opcion.value }))
    })
  }